
<template>
  <div class="main">
    <a-layout>
      <a-layout-header>
        <a-menu :default-selected-keys="[id]" :default-open-keys="['随机匹配小组']" theme="light">
          <a-menu-item v-for="item in classList" :key="item.id" class="siderBarName">
            <router-link :to="{name: item.name}">
                <span :id="item.text" v-trigger>{{item.text}}</span>
            </router-link>
          </a-menu-item>
        </a-menu>
      </a-layout-header>
      <a-layout-content :style="{ marginTop: '20px' }">
        <div :style="{ background: '#fff', minHeight: '120px' }">
          <router-view></router-view>
        </div>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import shareState from '../../utils/shareState.js'
export default {
    name: 'AddGroup',
  data () {
    return {
      id: 1,
      shareData: shareState.state,
      groupid: '',
      classId: '',
      classList: [
        { name: 'RandomGroup', text: '随机匹配小组', id: 1 },
        { name: 'AppointGroup', text: '指定小组成员', id: 2 }
      ]
    }
  },
watch: {
    // $route () {
    //     this.groupid = this.$route.params.groupid
    // }
  },
  mounted () {
    // this.groupid = this.$route.params.groupid
  },
  methods: {

  },
  directives:{
    trigger:{
        inserted (el,binding) {
          el.id == '随机匹配小组'? el.click() : null
        }
    }
  }
}
</script>
<style lang="less" scoped>
*{
  margin: 0px;
  padding: 0px;
}
  .main{
    width: 1240px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 50px;
  }
  .siderBarName{
    display: inline-block;
    width: 23%;
    margin: 5px 1%;
    height: 40px;
    border-radius: 12px;
    color: #000000;
    background: #fff;
    font-size: 18px;
    text-align: center;
  }
  .center{

  }
    // /deep/.ant-menu-vertical .ant-menu-item:not(:last-child), .ant-menu-vertical-left .ant-menu-item:not(:last-child), .ant-menu-vertical-right .ant-menu-item:not(:last-child), .ant-menu-inline .ant-menu-item:not(:last-child){
    //   margin-bottom: 0px;
    // }
  /deep/.ant-menu-item-selected > a, .ant-menu-item-selected > a:hover{
    background-image: linear-gradient(122deg,
		#ff8d46 0%,
		#fa5542 100%);
    box-shadow: 0px 2px 10px 0px
      #e1d9c2;
    border-radius: 12px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #fff;
  }
  /deep/.ant-layout-header{
    height: 52px;
    line-height: 60px;
    background: #f6f6f6;
    border-radius: 12px;
  }
  /deep/.ant-menu{
    // background: #f6f6f6;
  }
</style>